import styled from "styled-components";


export const ListPageTitle = styled.div`
    width: 100%;
    height: 50px;
    font-weight: 700;
    font-size: 26px;
    line-height: 50px;
    padding-left: 8px;
`

export const ContentListWrapper = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    padding-bottom: 50px;
`

export const ContentList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
    width: 100%;
`